import { 
  PURCHASE_GRADE_WISE_RATE_DIFF_REPORT_REQUEST, 
  PURCHASE_GRADE_WISE_RATE_DIFF_REPORT_SUCCESS, 
  PURCHASE_GRADE_WISE_RATE_DIFF_REPORT_FAILURE, 
  PURCHASE_GRADE_WISE_RATE_DIFF_FILTER_REPORT_REQUEST, 
  PURCHASE_GRADE_WISE_RATE_DIFF_FILTER_REPORT_SUCCESS, 
  PURCHASE_GRADE_WISE_RATE_DIFF_FILTER_REPORT_FAILURE 
} from "../types";
  
  const initialState = {
    purchaseGradeWiseRateDiffReportFilter: {},
    purchaseGradeWiseRateDiffReport: [],
    loading: false,
    error: null,
  };
  
  const purchaseGradeWiseRateDiffReportReducer = (state = initialState, action) => {
    switch (action.type) {
      case PURCHASE_GRADE_WISE_RATE_DIFF_REPORT_REQUEST: {
        return {
          ...state,
          loading: true,
          purchaseGradeWiseRateDiffReport: [],
          error: null
        };
      }
      case PURCHASE_GRADE_WISE_RATE_DIFF_REPORT_SUCCESS: {
        return {
          ...state,
          purchaseGradeWiseRateDiffReport: Array.isArray(action?.payload) ? action.payload : [],
          loading: false,
          error: null
        };
      }
      case PURCHASE_GRADE_WISE_RATE_DIFF_REPORT_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      case PURCHASE_GRADE_WISE_RATE_DIFF_FILTER_REPORT_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        }
      }
      case PURCHASE_GRADE_WISE_RATE_DIFF_FILTER_REPORT_SUCCESS: {
        return {
          ...state,
          purchaseGradeWiseRateDiffReportFilter: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case PURCHASE_GRADE_WISE_RATE_DIFF_FILTER_REPORT_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        }
      }
      default:
        return state;
    }
  };
  
  export default purchaseGradeWiseRateDiffReportReducer;
  